import { useLayoutEffect } from 'react';

const useScroll = (slug?: string) => {
  useLayoutEffect(() => {
    const id = window.location.href.split('#')[1] || '';
    const element = document.getElementById(id) || document.body;
    element.scrollIntoView({ behavior: 'smooth' });
  }, [slug]);

};
export default useScroll;
